import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/manualInvoices', request)
}

async function put(id, request) {
    return await putMethod(`/api/manualInvoices/${id}`, request)
}

export {get, put}
